var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDog2022 = function SvgDog2022(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none",
    viewBox: "0 0 72 72",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDE7E0",
    fillRule: "evenodd",
    d: "M10.23 65.222c-4.988-4.454-3.65-12.406-4.506-19.034-.825-6.39-1.797-12.568-.385-18.85 1.815-8.07 2.268-18.42 9.618-22.208 7.345-3.786 15.668 2.984 23.683 5.042 7.053 1.811 15.265 1.073 20.369 6.271 5.09 5.186 5.03 13.221 5.851 20.436.782 6.874 2.5 14.383-1.227 20.204-3.637 5.682-11.076 7.113-17.528 9.092-5.404 1.659-10.84 1.498-16.494 1.348-6.665-.177-14.404 2.145-19.381-2.3",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-1422629730__a)",
    d: "M27.115 53.664s.805 4.602 1.314 5.843c0 0 10.221 1.195 18.041-.602 7.82-1.796 12.13-4.228 12.13-4.228l.509-8.754z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B35E54",
    d: "M48.281 16.951S46.734 7.006 46.73 4.85l22.141 7.408s-9.175 7.23-16.189 13.108c-7.014 5.876-4.4-8.415-4.4-8.415"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-1422629730__b)",
    d: "M49.034 16.89s-2.3-9.884-2.304-12.04l22.141 7.408s-13.128 10.324-13.903 9.787a46 46 0 0 1-5.934-5.154"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#B35E54",
    d: "M24.494 22.73s-2.8-7.564-5.056-11.012c-.278-.428-7.003 19.358-7.24 19.816s7.432 4.564 10.143 5.373c2.71.81 2.199-12.487 2.153-14.177"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-1422629730__c)",
    d: "M23.81 23.38s-2.636-8.63-4.368-11.647c-.256-.443-1.506 3.358-.162 12.006.08.507 1.578 11.69 2.078 8.933.192-1.176 2.493-7.616 2.451-9.292"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-1422629730__d)",
    d: "M57.102 30.668a50.7 50.7 0 0 1-7.39-12.733s-10.689-.806-13.362-.946-12.8 6.387-12.8 6.387-.656 7.624-1.815 16.76c-1.171 9.266-3.32 14.715-3.32 14.715 2.134.416 6.332.042 9.347.477-2.413.2-5.448.412-5.448.412 4.827.685 15.339 1.713 22.315.238 2.813-.593 17.074-6.156 22.401-13.27-3.509-4.61-9.928-12.04-9.928-12.04"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-1422629730__e)",
    d: "M36.361 21.645c-5.884 1.89-9.197 3.403-12.668 9.95l.493 6.27s10.44 10.395 17.149 9.189c3.953-.711 9.849-5.12 12.108-10.32 1.581-3.631.196-8.699.196-8.699l-2.952-5.79c-2.267-1.985-9.864-2.034-14.326-.6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-1422629730__f)",
    d: "M31.256 40.814s6.427 13.368 22.834 18.315c2.575.775 8.121-10.827 8.731-13.437s-25.974-5.366-31.565-4.878"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-1422629730__g)",
    d: "M40.53 29.858s-2.301 11.97-9.274 10.967c0 0 7.037 9.832 19.408 12.42 0 0 4.349-3.877 7.763-6.524 0 0 3.686 2.681 4.164 2.356s6.826-14.053 7.643-16.261c0 0-19.415-2.186-25.624-3.865 0-.023.572-1.865-4.08.907"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-1422629730__h)",
    d: "M40.53 29.858s-2.493 9.405-9.274 10.967c0 0 10.689 9.273 19.054 8.921 0 0 4.959-1.664 7.907-3.653 0 0 4.457-.79 4.935-1.112.478-.321 6.265-9.968 7.082-12.188 0 0-19.897-2.833-26.11-4.512.016.015-1.148.015-3.595 1.577"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-1422629730__i)",
    d: "M40.53 29.858s1.644 7.745 2.198 10.18c0 0 10.075 1.76 13.554 1.604L67.2 33.058s-19.013-3.839-23.06-4.761c0 0-.66-.715-3.61 1.561"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-1422629730__j)",
    d: "M42.728 40.039s6.2 4.564 15.7 6.67c0 0 7.383-8.206 8.787-13.651 0 0-11.355-.719-24.487 6.98"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-1422629730__k)",
    d: "M65.163 33.065c-3.645.163-11.747 1.135-20.922 6.123 7.828 2.859 16.332.2 20.922-6.123"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-1422629730__l)",
    d: "M44.241 39.188q-.753.408-1.506.85s6.201 4.565 15.7 6.672c0 0 7.383-8.207 8.787-13.652 0 0-.753-.05-2.052 0-4.596 6.33-13.101 8.989-20.929 6.13"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-1422629730__m)",
    d: "M19.438 11.718s.79 6.292.467 16.476c-.237 7.325-1.08 11.66-1.08 11.66S7.906 36.853 0 32.644A75.6 75.6 0 0 1 8.588 21.46c5.433-5.918 11.904-10.471 10.85-9.741"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-1422629730__n)",
    d: "M46.73 4.85c1.201.4 4.691 5.79 7.199 9.704s7.217 11.75 7.57 12.045c.355.294 6.898-6.622 10.501-13.743a64 64 0 0 0-12.27-5.442 61.2 61.2 0 0 0-13-2.564"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-1422629730__o)",
    d: "M55.434 56.856c-3.588.832-10.876-3.843-10.876-3.843s5.432.923 6.294.81c1.906-.242 5.524-4.882 6.856-5.193.58-.136 2 .81 2.854 1.24.17.088-3.622 6.634-5.128 6.986"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-1422629730__p)",
    d: "M40.53 29.858s-3.728-6.24-9.688-8.028c0 0 3.577-3.46 4.717-3.733 2.086-.499 7.828.45 7.828.45s-2.173 3.892.753 9.75a10 10 0 0 0-3.61 1.561"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E1CDBB",
    d: "M23.55 23.38s8.071.435 13.177-.756c4.517-1.074 12.985-4.69 12.985-4.69s-12.052-.983-13.592-.983-6.159 2.666-12.57 6.43",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#556A7A",
    d: "M53.304 37.059c-4.567-.624-10.03 3.615-5.569 3.846 4.462.23 7.203-3.623 5.569-3.846",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-1422629730__q)",
    d: "M26.63 32.15s2.714 2.197 4.758 1.732 3.129-3.85 3.129-3.85-2.854-2.45-4.142-2.163c-2.56.582-3.746 4.281-3.746 4.281"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-1422629730__r)",
    d: "M30.394 27.87c-3.193.85-1.329 5.123 1.13 4.56 3.023-.692.944-5.117-1.13-4.56"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-1422629730__s)",
    d: "M27.932 30.566c-.926 1.02.094 3.191 2.09 1.61 1.6-1.274-.366-3.501-2.09-1.61",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E320A",
    d: "M26.588 31.976a45 45 0 0 1 1.713-1.997 8.4 8.4 0 0 1 1.909-1.61q.253-.139.53-.22h.23q.128 0 .252.026c.39.098.762.252 1.107.458.753.42 1.446.934 2.18 1.44a8 8 0 0 0-1.882-1.94 3.8 3.8 0 0 0-1.273-.638 2 2 0 0 0-.403-.053 2 2 0 0 0-.226 0h-.098l-.094.022q-.361.095-.685.284c-.406.233-.779.522-1.107.858a8 8 0 0 0-.88 1.037 10.5 10.5 0 0 0-1.273 2.333"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-1422629730__t)",
    d: "M45.115 26.784s.316-3.158 1.634-3.96c1.668-1.013 4.63 1.426 4.63 1.426s-.32 2.534-1.761 3.29c-1.356.722-4.503-.756-4.503-.756"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-1422629730__u)",
    d: "M47.152 22.68c-.866.224-1.578 1.66-.753 2.935.824 1.275 3.211 1.573 3.388-.181s-.591-3.283-2.635-2.753"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-1422629730__v)",
    d: "M45.616 25.052c-.524 1.176.297 2.78 2.157 1.3 1.498-1.187-1.337-3.138-2.158-1.3",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E320A",
    d: "M45.186 26.28c.213-.707.492-1.392.836-2.045.339-.616.806-1.134 1.4-1.274a3.56 3.56 0 0 1 1.981.313 17 17 0 0 1 1.988.987 6.6 6.6 0 0 0-1.77-1.448 4.6 4.6 0 0 0-1.092-.454 2.7 2.7 0 0 0-1.25-.053c-.435.095-.83.323-1.129.654-.274.306-.488.66-.632 1.044a5.2 5.2 0 0 0-.332 2.277"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-1422629730__a",
    x1: 48.641,
    x2: 46.466,
    y1: 61.529,
    y2: 51.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#523F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#192B22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-1422629730__b",
    x1: 61.919,
    x2: 56.489,
    y1: 9.423,
    y2: 24.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D97373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5957F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-1422629730__c",
    x1: 12960.5,
    x2: 13197.8,
    y1: 8857.92,
    y2: 8822.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D97373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5957F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-1422629730__d",
    x1: 47.823,
    x2: 38.999,
    y1: 58.354,
    y2: 19.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#763F0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#522C0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-1422629730__e",
    x1: 40.459,
    x2: 46.139,
    y1: 26.828,
    y2: 50.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD6C31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#AC612A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#985423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#8A4B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#82461B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#80441A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-1422629730__f",
    x1: 48.987,
    x2: 58.56,
    y1: 41.508,
    y2: 65.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C816C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3BEAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-1422629730__g",
    x1: 35.475,
    x2: 74.476,
    y1: 46.493,
    y2: 37.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE9A88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6C1AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-1422629730__h",
    x1: 35.09,
    x2: 74.091,
    y1: 44.77,
    y2: 36.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4AD99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECD9C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-1422629730__i",
    x1: 59.732,
    x2: 51.962,
    y1: 41.308,
    y2: 25.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECD9C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-1422629730__j",
    x1: 60.869,
    x2: 58.117,
    y1: 49.273,
    y2: 37.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#533A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#211B16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-1422629730__k",
    x1: 59.064,
    x2: 57.965,
    y1: 41.976,
    y2: 37.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6E5540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B3929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-1422629730__l",
    x1: -51242,
    x2: -51242,
    y1: 6576.05,
    y2: 6149.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#533A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#211B16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-1422629730__m",
    x1: -0.359,
    x2: 23.617,
    y1: 30.895,
    y2: 22.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#522C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A4A0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-1422629730__n",
    x1: 54088.2,
    x2: 53555.6,
    y1: -2907.08,
    y2: -4003.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#522C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A4A0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-1422629730__o",
    x1: 48.552,
    x2: 64.539,
    y1: 57.683,
    y2: 54.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4D0BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#E1CDBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-1422629730__p",
    x1: -27103.1,
    x2: -27561.5,
    y1: 4874.33,
    y2: 4874.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4D0BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#E1CDBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-1422629730__r",
    x1: 34.846,
    x2: 33.806,
    y1: 34.641,
    y2: 30.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33200E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-1422629730__s",
    x1: 31.032,
    x2: 34.077,
    y1: 33.773,
    y2: 33.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C576E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D6E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-1422629730__u",
    x1: -7824.36,
    x2: -7824.36,
    y1: 1743.13,
    y2: 1697.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33200E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-1422629730__v",
    x1: -5647.53,
    x2: -5667.8,
    y1: 1129.54,
    y2: 1129.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C576E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D6E4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg-1422629730__q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.51988 -.7937 .7969 3.53405 34.01 33.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEB04D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#E8AB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D69C44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#B98438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B37F36"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg-1422629730__t",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-50.2437 0 0 -41.3915 -13007.1 2174.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEB04D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#E8AB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D69C44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#B98438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B37F36"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDog2022);
export default ForwardRef;